import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { CROHero } from "@/components/cro-testing/HeroSection";
import { OptimizationProcess } from "@/components/cro-testing/OptimizationProcess";
import { TestingTypes } from "@/components/cro-testing/TestingTypes";
import { CaseStudyHighlight } from "@/components/cro-testing/CaseStudyHighlight";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const CROTesting = () => {
  return (
    <ServiceLayout serviceName="CRO Testing">
      <CROHero />
      <OptimizationProcess />
      <TestingTypes />
      <CaseStudyHighlight />
      <ServiceFAQ faqs={serviceFAQs["cro-testing"]} serviceName="CRO Testing" />
      <ServiceCTA serviceName="CRO Testing" />
    </ServiceLayout>
  );
};

export default CROTesting;